import { render, staticRenderFns } from "./KitConfiguracion.vue?vue&type=template&id=ec8e0a2c&scoped=true"
import script from "./KitConfiguracion.vue?vue&type=script&lang=js"
export * from "./KitConfiguracion.vue?vue&type=script&lang=js"
import style0 from "./KitConfiguracion.vue?vue&type=style&index=0&id=ec8e0a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8e0a2c",
  null
  
)

export default component.exports